(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/hooks/use-draws.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/hooks/use-draws.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useEffect,
  useState
} = React;
const {
  fetchDraws
} = svs.tt.services;
const useDraws = productSetting => {
  const [state, setState] = useState({
    draws: [],
    availableSports: [],
    loading: Boolean(productSetting)
  });
  useEffect(() => {
    if (!productSetting || productSetting.productType === 'start') {
      setState({
        draws: [],
        availableSports: [],
        loading: false
      });
      return () => {};
    }
    let cancelled = false;
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      loading: true
    }));
    (async () => {
      try {
        const result = await fetchDraws(productSetting);
        if (cancelled) {
          return;
        }
        setState({
          draws: result.draws || [],
          availableSports: result.availableSports || [],
          loading: false
        });
      } catch (error) {
        if (cancelled) {
          return;
        }
        if (svs.tt.logger) {
          svs.tt.logger.error("Failed to fetch draws for ".concat(productSetting.productType, ": ").concat(error));
        }
        setState({
          draws: [],
          availableSports: [],
          loading: false
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [productSetting]);
  return state;
};
setGlobal('svs.tt.hooks.useDraws', useDraws);

 })(window);